<template>
  <div
    v-if="darkSide"
    class="header-dark"
  >
    <div class="header-container">
      <div
        v-for="item in 40"
        :key="item"
        class="inline-block w-16 p-2"
      >
        <div class="pb-1">
          {{ item | pad }}
        </div>
        <div>0-{{ item | pad }}</div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="header"
  >
    <span class="hidden sm:block">
      NACS INTRANET SERVER
      <span class="font-bold">V2.4</span>
    </span>
    <SidebarMobile
      v-if="isLoggedIn"
      class="sm:hidden"
      @open="$emit('sidebar-opened')"
    />
    <img
      src="../../assets/eb-l-nacs-logo.png"
      class="h-6 sm:h-12"
    >
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import SidebarMobile from './SidebarMobile.vue'

export default {
  name: 'TheHeader',

  components: {
    SidebarMobile,
  },

  filters: {
    pad(value) {
      if (value < 10) {
        return `0${value}`
      }
      return value
    },
  },

  computed: {
    ...mapState({
      darkSide: state => state.auth.dark,
    }),

    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },
}
</script>
<style lang="postcss" scoped>
.header {
  height: 44px;
  font-family: 'univia-pro';
  font-size: 40px;
  font-weight: 300;
  box-shadow: 21px 21px 14px 0 rgba(0, 0, 0, 0.5);
  @apply bg-blue-darkest flex justify-between items-center p-4 text-blue border-b-2 border-blue z-10;

  &-container {
    width: 3000px;
  }

  &-dark {
    margin-top: 45px;
    height: 43px;
    font-size: 12px;
    font-family: 'input-mono';
    @apply bg-dark-black border border-blue text-blue w-full overflow-hidden;
  }
}

@screen sm {
  .header {
    height: 102px;

    &-dark {
      margin-top: 0;
    }
  }
}
</style>
